<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>

    <h1 class="modalTitle">
      <mat-icon class="iconPosition">photo</mat-icon>
      Add Image
    </h1>
  </section>
  <section class="description" mat-dialog-actions>
    Click on an existing image to add to page, or add a new image.
    <button
      (click)="addNewImage()"
      mat-button
      title="Add new image."
      type="button"
      >
      <mat-icon>add_box</mat-icon>
      Add Image
    </button>
  </section>
  <section mat-dialog-content>
    @for (image of OrganisationImages; track image) {
      <section
        (click)="selectImage(image)"
        [ngClass]="{'selected' : selectedImages.includes(image)}"
        >
        <img
          [src]="getImageUrl(image)"
          [title]="image.file_title"
          alt="{{image.file_title}}"
          loading="lazy"
          />
        <!-- The company image selectable -->
      </section>
    }
  </section>
  <section align="end" mat-dialog-actions>
    <button
      (click)="addImage()"
      [disabled]="!selectedImages.length || loading"
      mat-button
      matTooltip="Add image."
      >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</section>
